export const mail = {
  '站内信': '站内信',
  '返回': '返回',
  '有未读信息': '有{amount}条未读信息',
  '全部标记为已读': '全部标记为已读',
  '隐藏已读消息': '隐藏已读消息',
  '展开': '展开',
};


// WEBPACK FOOTER //
// ./src/i18n/lang/mail/zh.js